import React from 'react'
import PropTypes from 'prop-types'

export default function PlayerHistoryHeader({
  player,
  overallStats,
  winPercentage,
}) {
  return (
    <div className="row mb-4">
      <div className="col-12">
        <div className="player-history-hero card border-0 shadow-sm bg-primary text-white">
          <div className="card-body p-4">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="display-6 mb-2">
                  {player.first_name} {player.last_name}
                </h2>
                <p className="mb-0 opacity-75">
                  Complete Match History Across All Leagues
                </p>
              </div>
              <div className="col-md-4">
                <div className="row text-center">
                  <div className="col-4">
                    <div className="h3 mb-1">{overallStats.totalMatches}</div>
                    <div className="small opacity-75">Matches</div>
                  </div>
                  <div className="col-4">
                    <div className="h3 mb-1">
                      {overallStats.wins}-{overallStats.losses}
                    </div>
                    <div className="small opacity-75">W-L Record</div>
                  </div>
                  <div className="col-4">
                    <div className="h3 mb-1">{winPercentage}%</div>
                    <div className="small opacity-75">Win Rate</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

PlayerHistoryHeader.propTypes = {
  player: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  overallStats: PropTypes.shape({
    totalMatches: PropTypes.number.isRequired,
    wins: PropTypes.number.isRequired,
    losses: PropTypes.number.isRequired,
  }).isRequired,
  winPercentage: PropTypes.number.isRequired,
}
